export default __webpack_public_path__ + "static/media/packages-generic.712164fb.gif";